export default __webpack_public_path__ + "static/media/tiRed.331c2ca7.svg";